<template>
  <organization-control-detail :audit-id="auditId" :back-url="backUrl" />
</template>

<script>
import OrganizationControlDetail from "../control/organization-control-detail.vue";

export default {
  components: { OrganizationControlDetail },
  computed: {
    auditId() {
      // Eğer rota /audit-control/audit/detail/:id/control/:controlId ise audit id = $route.params.id
      if (this.$route.params.controlId) {
        return this.$route.params.id;
      }
      // Rota /audit-control/audit/control/:id/detail formatında ise id bir kontrol id'sidir
      return null;
    },
    backUrl() {
      // Geri dönüş rotasını belirleme
      if (this.$route.query.from === "audit-view") {
        return "/audit-control/audit";
      }
      if (this.$route.params.controlId) {
        return `/audit-control/audit/detail/${this.$route.params.id}`;
      }
      return "/audit-control/audit";
    },
  },
};
</script>
